import React from 'react'
import { Button, ButtonWithIcon, StyledText } from '@clickcease/cc-client-components-lib'

import { DescriptionBlock, FooterContainer } from './MultipleDomains.styles'
import { SelectOption } from 'Types/Option'
import { validateDomain } from 'Utils/validation'
import { MultipleDomainInput } from '../features/MultiDomainInput'
import { useTranslation } from 'react-i18next'
import { Plus } from 'Assets/icons/Plus'
import { trimPrototcolAndWww } from 'Utils/routes'

interface MultipleDomainsProps {
  onOpenChange: (a: boolean | number) => void
  domains: SelectOption[]
  setDomains: (a: SelectOption[]) => void
  finishStep: () => void
}

const createOption = (label: string): SelectOption[] => [
  {
    label,
    value: trimPrototcolAndWww(label),
  },
]

export const AddDomainsStep = ({
  onOpenChange,
  domains,
  setDomains,
  finishStep,
}: MultipleDomainsProps) => {
  const { t } = useTranslation('domainManagement')
  const isButtonDisabled = domains.length === 0

  // in case used pastes space separated domains
  const makeDomainsFromStringSpaceSeparated = (input: string) => {
    const domainsArray = input.split(/,| /).map((domain) => domain.toLowerCase()) // parse the domain - save as lower case
    const domainsValidated = domainsArray.filter((domain) => validateDomain(domain))
    const domainsOptions = domainsValidated.map((domain) => createOption(domain))
    setDomains([...domains, ...domainsOptions].flat())
  }

  const addDomain = (inputValue: string) => {
    makeDomainsFromStringSpaceSeparated(inputValue)
  }

  return (
    <>
      <DescriptionBlock>
        <StyledText variant={'baseRegular'}>
          {t('add_new_domain_modal.description_first_line')}
        </StyledText>
        <StyledText variant={'baseRegular'}>
          {t('add_new_domain_modal.description_second_line')}
        </StyledText>
      </DescriptionBlock>
      <MultipleDomainInput addDomain={addDomain} domains={domains} setDomains={setDomains} />
      <FooterContainer>
        <Button
          variant="ghost"
          text={t('add_new_domain_modal.cancel')}
          onClick={() => {
            onOpenChange(0)
          }}
        />
        <ButtonWithIcon
          iconLeft={
            <Plus stroke="#ffffff" fill={isButtonDisabled ? '#CACACA' : 'rgba(225, 36, 104, 1)'} />
          }
          disabled={isButtonDisabled}
          text={t('add_new_domain_modal.add_domains')}
          onClick={finishStep}
        />
      </FooterContainer>
    </>
  )
}
